export const TRANSLATIONS_EN = {
  join_eui: "Join EUI",
  app_key: "App Key",
  email: "Email",
  password: "Password",
  forgotpassword: "Forgot password?",
  email_field_is_required: "Email field is required",
  reset_password: "Reset Password",
  password_field_is_required: "Password field is required",
  password_do_not_match: "Password do not match",
  invalid_email_address: "Invalid email address",
  leave_empty_to_keep_current: "Leave empty to keep current password",
  enter_email_address: "Enter email address",
  create_account: "Create Account",
  dont_have_an_account: "Don't have an account ?",
  already_have_an_account: "Already have an account?",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Enter the email address associated with your account and we will send you a link to reset your password.",
  back_to_login: "Back to login",
  login: "Login",
  nav: {
    dashboard: "Dashboard",
    inventory: "Inventory",
  },
  inventory: "Inventory",
  inventory_title: "Inventory Management",
  add_inventory_item: "Add Item",
  edit_inventory_item: "Edit Item",
  current_stock: "Current Stock",
  low_stock_threshold: "Low Stock Threshold",
  low_stock_only: "Low Stock Only",
  unit_of_measure: "Unit",
  purchase_link: "Purchase Link",
  batch_update_save: "Save Changes",
  batch_update_success: "Inventory updated successfully",
  item_created_success: "Item created successfully",
  item_updated_success: "Item updated successfully",
  item_deleted_success: "Item deleted successfully",
  item_delete_confirm: "Are you sure you want to delete this item?",
  dashboard: {
    title: "Production Dashboard",
    total_produced: "Total Produced",
    qc_passed_unassigned: "Current Stock",
    all_time: "All Time",
    current_year: "Current Year",
    all_quarters: "All Quarters",
    usage_distribution: "Usage Distribution",
    production_volume: "Production Volume",
    qc_passed_only: "QC Passed Only",
  },
  logout: "Log Out",
  users: "Users",
  username: "Username",
  save: "Save",
  name: "Name",
  signup: "Signup",
  address: "Address",
  confirm: "Confirm",

  sensor_details: {
    empty_sensors: "Empty Sensor, please start adding trees.",
    no_sensor_selected: "Please select sensor to view details",
    no_data_found: "No Sensor Data Found",
  },
  sensors: "Sensors",
  projects: "Projects",
  edit: "Edit",
  delete: "Delete",
  trees: "Trees",
  customers: "Customers",
  customer: "Customer",
  actions: "Actions",
  battery: "Battery",
  threshold: "Threshold",
  settings: "Settings",
  notifications: "Notifications",
  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "The unique identification of the sensor. It can be found on the sticker on the transmitter module. For LoRaWAN sensors it is the DevEUI and for NB-IoT sensors it is the IMEI.",
  imei: "IMEI",
  add_sensor: "Add Sensor",
  add_user: "Add User",
  edit_sensor: "Edit Sensor",
  email_notification: "E-Mail Notifications",
  email_schedule: "E-Mail Schedule",
  weekly_summary_email: "Weekly summary email",
  daily_changes_email: "Daily changes email",
  manage_users_description: "Manage user accounts and permissions",
  manage_customers_description: "Manage customer information and access",
  statistics: "Statistics",
  customer_statistics_description: "View customer statistics and data overview",

  sensor_status_change_to_no_connection: "Sensor status change to no connection",
  sensor_status_change_to_dry: "Sensor status change to dry",
  sensor_status_change_to_drying_out: "Sensor status change to drying out",
  error: {
    this_field_is_required: "This field is required",
    something_went_wrong: "Something Went Wrong",
    loading_customers: "Error Loading Customers",
    loading_users: "Error Loading Users",
  },
  error_label: "Error",
  first_name: "First Name",
  last_name: "Last Name",
  profile: "Profile",
  phone_number: "Phone number",
  account_type: "Account Type",
  city: "City",
  street_name: "Street Name",
  house_number: "House Number",
  country: "Country",
  zip_code: "Zip Code",
  day: {
    sun: "Sunday",
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sat: "Saturday",
  },
  admin: "Admin",
  basic: "Basic",
  export: "Export",
  select_customer_type: "Select Customer Type",
  customer_type: "Customer Type",
  change_image: "Change Image",
  update_image: "Update Image",
  update_customer_logo_description: "Upload and update your organization logo",
  change_language: "Change language",
  time: "Time",
  search_sensor: "Search Sensor",
  resistance: "Resistance",
  download_sensor_data: "Download sensor data",
  temperature: "Temperature",
  loading: "Loading ...",
  button: {
    back: "Back",
    next: "Next",
    save: "Save",
    reset: "Reset",
    saving: "Saving ...",
    update: "Update",
    updating: "Updating ...",
    add_sensor: "Add Sensor",
    add_customer: "Add Customer",
    edit_customer: "Edit Customer",
    cancel: "cancel",
    discard: "Discard",
  },
  user_form: {
    profile: "Profile",
    address: "Address",
    basic_info: "Basic Info",
    login_credentials: "Login Credentials",
    areas: "Irrigation Areas",
  },
  sensor_form: {
    name: "Name",
    threshold: "Threshold",
    hardware_serial: "Hardware Serial",
    sensor_type: "Sensor Type",
    network_type: "Network Type",
  },
  add_all_form: {
    title: "Add tree with sensor in area",
    sensor: {
      title: "Sensor",
      explanation:
        "Do you want to a Sensor add an existing Tree or do you want to create a new one?",
      new_sensor: "Add a new Sensor",
      existing_sensors: "Choose existing Sensors",
    },
    tree: {
      title: "Tree",
      explanation:
        "Do you want to add an existing Tree or do you want to create a new one?Hier kann ein neuer Sensor erstellt und dem Baum hinzugefügt werden. Oder aber ein bereits bestehender Sensor kann ausgewählt werden, um ihn dem hinzuzufügen.",
      new_tree: "Create a new Tree",
      existing_tree: "Choose an existing Tree",
    },
    area: {
      title: "Area",
      explanation:
        "Do you want to add the Tree to an existing Area or do you want to create a Area and add the Tree to it?",
      new_area: "Create a new Area",
      existing_area: "Choose an existing Area",
    },
  },
  create_new_tree: "Create new Tree",
  validation: {
    email_is_required: "Email is required",
    password_is_required: "Password is required",
    invalid_email_address: "Invalid email address",
    name_is_required: "Name is required",
    hardware_serial_is_required: "Hardware serial is required",
    user_with_this_email_already_exist: "User with this email already exist",
    all_address_field_are_required: "All address field are required",
    position_is_required: "Position is required",
    invalid_house_number: "Invalid house number",
    user_limit_exceeded_for_your_package: "User limit exceeded for your package",
    sensor_limit_exceeded_for_your_package: "Sensor limit exceeded for your package",
    imei_must_be_15_digits: "IMEI must be exactly 15 digits.",
    hardware_serial_must_be_16_characters: "Hardware serial must be exactly 16 characters.",
    must_be_a_number: "Value must be a number",
    out_of_range: "Value must be between {{min}} and {{max}}",
  },

  drag_the_below_variables_to_graph_area: "Drag the below variables to graph area",
  drop_left: "Drop Left",
  drop_right: "Drop Right",
  drop_the_variable_to_get_data: "Drop the variable. Go on!",
  no_data_available_please_check_data_available_to_this_date:
    "No data available, please check data available to this date",
  unable_to_upload_file: "Unable to upload file",
  file_upload_successfully: "File upload successfully",
  no_tree_is_selected: "No tree is selected",
  no_sensor_is_selected: "No sensor is selected",
  areaName: "Name",
  childTree: "Child Tree",
  add_child_tree: "Add child tree",
  parentTree: "Parent Tree",
  area: "Area",
  areas: "Areas",
  start_with_adding_new_project: "Start with adding new project",
  resis_temp_comp: "ResisTempComp",
  health_of_tree_is_good: "Health state of tree is good",
  health_of_tree_is_drying_out: "Health of tree is drying out",
  health_of_tree_is_poor: "Health of tree is poor",
  sensor_disconnect: "Sensor disconnect",
  battery_full: "Battery full",
  less_than_60_of_the_battery_remaining: "Less than 60% of the battery remaining",
  battery_is_getting_low: "Battery is getting low",
  size: "Size",
  type: "Type",
  map_view: "Map view",
  records: "Records",
  status: "Status",
  welcome_back: "Welcome Back!",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Looks like you don't have selected  area. Please select an area to get data.",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "Looks like you don't have selected tree. Please select a tree to get data.",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Looks like you don't have selected  sensor. Please select a sensor to get data.",
  please_drag_the_variable_to_display_data: "Please drag the variable to display data.",
  click_on_marker_to_select_tree: "Click on marker to select tree",
  next_irrigation: "Next Irrigation",
  mean: "Mean",
  sensor_state: "Sensor State",
  state: "State",
  moisture_content: "Treesense Moisture Index",
  card_number: "Card Numer",
  card_name: "Card Name",
  expiration_date: "Expiration Date",
  continue: "Continue",
  today: "Today",
  tomorrow: "Tomorrow",
  days_left: "days left",
  days: "Days",
  personal_data: "Personal data",
  language: "Language",
  saved: "Saved",
  payment: "Payment",
  benifits: "Benifits",
  change_logo: "Change logo",
  role: "Role",
  amount_nodes: "Amount sensor nodes",
  last_battery: "Last Battery",
  characters: "Characters",
  maximum_of: "Maximum",
  stop_scanning: "Stop Scanning",
  last_measurements: "Last Measurements",
  adjust_thresholds_crown: "Adjust Thresholds for the Crown Sensors",
  adjust_thresholds_soil: "Adjust Thresholds for the Soil Sensors",
  set_default: "Set Default",
  meaning_measurement: "Meaning of Measurement",
  download_tree_list: "Download Tree List (.xlsx)",
  download_tree_details: "Download Details of Trees (.pdf)",
  not_provided: "Not provided",
  soil_moisture_edit: "Thresholds vol. Soil Moisture",
  soil_water_tension_edit: "Thresholds Soil Water Tension",
  select_language: "Select Language",
  user: "User",
  edit_user: "Edit User",

  superuser: "Super User",
  dendrometer: "Dendrometer",
  diameter: "Diameter",
  network_type: "Network Type",
  sensor_type: "Sensor Type",
  lora_wan: "LoRaWAN",
  nb_iot: "NB-IoT",
  area_form: {
    existing_area: "Existing area",
  },
  new_area: "New Area",
  existing_area: "Existing Area",
  explanation: "Explanation",
  add_area: "Add Area",
  battery_empty: "Battery Empty",
  maintenance_needed: "Maintenance Nedded",
  All: "All",
  tree_count: "Tree Count",
  demo_project_warning: {
    title: "Demo Account",
    description:
      "You are currently using a demo account and have limited permissions.\nIf you are already a customer and would like access to your customer account, please contact support: support@treesense.net.\nIf you are not yet a customer, you can order sensors through our shop at https://www.treesense.net",
  },
  image_upload_info: {
    title: "Upload of tree images possible",
    description:
      "To optimize our tree health formula for your trees, we offer the option to upload images of your tree in the tree list.",
  },
  add_tree_img: "Add Tree Image",
  datetime_photo: "Time of image capture",
  upload_tree_img: "Upload Tree Image",
  upload_leaf_img: "Upload Leaf Image",
  pulse_sensor: "Pulse Sensor",
  soil_moisture_sensor: "Soil Moisture Sensor",
  soil_moisture: "Soil Moisture",
  soil_water_tension_sensor: "Soil Water Tension Sensor",
  soil_water_tension: "Soil Water Tension",
  dendrometer_sensor: "Dendrometer Sensor",
  here: "here",
  manual: {
    sign_up: {
      title: "Registration",
      list: {
        1: "Register on cloud.treesense.net",
        2: "Notify [customer support](mailto:support@treesense.net)",
      },
    },
    add_sensor: {
      title: "Create a sensor/project",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    view_data: {
      title: "View sensor data",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    irrigation: {
      title: "Next irrigation",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    api: {
      title: "Interface/API",
      description:
        "The documentation for the interface can be accessed [here](https://api.treesense.net/docs).",
    },
  },
  views_per_page: "View per Page",
  customer_attributes: "Customer Attributes",
  paid: "paid",
  maintenances: "Maintenances",
  add_maintenance: "Add Maintenance",
  list_maintenances: "List Maintenances",
  tree_profile: {
    tree_species_knowledge: "Facts",
    tree_species: "Interesting Facts",
    tree_info: "Tree Information",
    want_to_know_more: "Would you like to learn more?",
    learn_more: "Click here to learn more",
  },
  root_system: {
    UN: "Unknown",
    SH: "Shallow-rooted",
    DE: "Deep-rooted",
    HE: "Heart-rooted",
  },
  latin_name: "lat. Name",
  german_name: "ge. Name",
  tree_species: "Tree Species",
  depth: "Depth",
  healthy: "Healthy",
  not_sending: "Not Sending",
  working: "Working",
  unknown: "Unknown",
  add_installation: "Add Installation",
  select_sensor: "Select Sensor",
  select_depth: "Select Depth",
  installed_at: "Date of Installation",
  removed_at: "Date of Removal",
  hardware_serial_no: "Hardware Serial",
  required_information: "* Required Information",
  include_calculated_values: "include calculated values",
  calculated_values_wip:
    "The calculated values (moisture_content, resis_temp_comp) are still work in progress. Please use them with caution. Please select if you want to download the calculated values as well.",
  last_10_measurements: "Last 10 measurements",
  soil_name: "Soil Name",
  optional_soil_name: "Optional soil name",
  tree_name: "Tree Name",
  permanent_wilting_point: "Permanent wilting point",
  effective_field_capacity: "Effective field capacity",
  field_capacity: "Field capacity",
  soil: "Soil",

  sensor_status: "Sensor Status",
  sensor_status_description:
    "The sensor status indicates whether the sensor is working or whether it requires maintenance",
  download_success: "Download successful.",
  download_failed: "Download failed. Please try again.",
  timeframe: "Timeframe",
  timeframe_hint:
    "Leave as-is to download the last 30 days. Adjust the range to narrow your export.",
  invalid_date_range: "Start date must be before end date.",

  // Sensor Lookup translations
  sensor_list: "Sensor List",
  sensor_lookup: "Production",
  tui_part: "TUI Part",
  enter_tui_part_placeholder: "Enter part of the TUI (e.g., A84041AA)",
  tui_search_help: "Enter part of the sensor's TUI to search",
  searching: "Searching...",
  search: "Search",
  no_sensors_found: "No sensors found",
  sensor_not_found: "Sensor not found",
  sensor_not_found_message: "No sensor found with the provided TUI part.",
  customer_not_found: "Customer not found",
  customer_not_found_message: "No customer could be found with the provided Cloud ID or Name.",
  last_sensor_event: "Last Sensor Event",
  multiple_sensors_found: "Multiple sensors found",
  multiple_sensors_found_message:
    "Multiple sensors match your search. Please click on one of the TUIs below to select it",
  sensor_events: "Sensor Events",
  no_sensor_events_found: "No sensor events found for this sensor.",
  qc_passed: "QC Passed",
  passed: "Passed",
  failed: "Failed",
  comments: "Comments",
  tui: "TUI",
  created_at: "Created At",
  assign_sensor: "Assign sensor",
  create_customer: "Create customer",
  customer_info: "Customer information",
  customer_name_or_cloud_id: "Customer ID or Name",
  download_csv: "Download project data (TSV files)",
  download_project_data: "Download all sensor data of the project",
  enter_customer_name: "Enter customer ID or name",
  enter_customer_name_or_cloud_id: "Enter Customer Name or Cloud ID",
  enter_domain: "Enter domain",
  enter_name: "Enter name",
  package: "Package",
  search_area: "Area search",
  usage: "Usage type",
  variables: "Variables / Values",
  leih: "Loan",
  none: "None",
  qr_Scanner: "QR Scanner",
  selectcamera: "Select Camera",
  sensorevent: "Sensor Event",
  cloud_id: "Cloud ID",
  creating: "Creating",
  customer_created_successfully: "Customer Created Successfully",
  customer_creation_failed: "Customer Creation Failed",
  customer_creation_code: "Customer Creation Code",
  customer_name: "Customer Name",
  customer_sensors: "Customer Sensors",
  domain: "Domain",
  enter_cloud_id: "Enter Cloud ID",
  enter_comments: "Enter Comments",
  fetch: "Fetch",
  fetching: "Fetching...",
  last_created_customer: "Last Created Customer",
  lorawan_keys_fetch_failed: "Lorawan Keys Fetch Failed",
  lorawan_keys_list: "Lorawan Keys List",
  lost: "Lost",
  no_change: "No Change",
  no_lorawan_keys_found: "No Lorawan Keys Found",
  not_found: "Not Found",
  projects_views: "Projects",
  rented: "Rented",
  replaced: "Replaced",
  research: "Research",
  sensor_assigned_successfully: "Sensor Assigned Successfully",
  sensor_assignment_failed: "Sensor Assignment Failed",
  sensors_views: "Sensors",
  sold: "Sold",
  assigned_from_date: "Assigned from (optional)",
  assigned_from_date_help: "Leave empty to start from today",
  assigned_until_date: "Assigned until (optional)",
  assigned_until_date_help: "Leave empty for indefinite assignment",
  optional: "Optional",
  search_sensors: "Search sensors by name, DevEUI or IMEI...",
  showing_results: "Showing {{count}} result(s)",
  close: "Close",
  more_actions: "More actions",
  start_scanning: "Start Scanning",
  trees_views: "Trees",
  unknown_customer: "Unknown Customer",
  update_sensor_values: "Update Sensor Values",
  download: "Download",
  sensor_return: "Sensor Return",
  sensor_return_title: "Return Sensor to Stock",
  sensor_return_description:
    "Unassign a sensor from its current customer by setting the return date. This will automatically end the current assignment.",
  sensor_return_tui_help: "Enter the TUI to identify the sensor",
  return_date: "Return Date",
  return_date_help: "Date when the sensor was returned",
  return_date_help_default_today:
    "Date when the sensor was returned, if left empty, today's date will be used",
  unassign_sensor: "Return Sensor",
  sensor_returned_successfully: "Sensor returned successfully",
  sensor_return_failed: "Failed to return sensor",
  success: "Success",
  currently_assigned_to: "Currently assigned to",
  assigned_since: "Assigned since",
  sensor_not_assigned_to_customer: "This sensor is not currently assigned to any customer.",
  manage_customers: "Manage Customers",
  customer_details: "Customer Details",
  customer_id: "Customer ID",
  total_sensors: "Total Sensors",
  total_probes: "Total Probes",
  customer_sensors_list: "Customer Sensors List",
};
